import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertController, IonContent, IonItemSliding, IonRouterOutlet, LoadingController, ModalController, NavParams, Platform, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription, interval } from 'rxjs';
import { FcmService } from '@shared/services/fcm.service';
import { MatchService } from 'src/app/services/match.service';
import { UserService } from '@shared/services/user.service';
import { Preferences } from '@capacitor/preferences';
import { UtilService } from '@shared/utils/util';
import { PicturesPage } from '../pictures/pictures.page';
import { PurchaseService } from 'src/app/services/purchase.service';
import { ProfileDisplayPage } from '../profile-display/profile-display.page';
import { StoreV2Page } from '../store-v2/store-v2.page';
import { MediaService } from '@shared/services/media.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { Autosize } from '@shared/components/autosize';
import { FileUploadResult } from '@awesome-cordova-plugins/file-transfer';
import { GenericResponse, VoiceRecorder } from 'capacitor-voice-recorder';
import { EventService } from '@shared/services/event.service';
import { AndroidSettings, IOSSettings } from 'capacitor-native-settings';
import { ShareProfileComponent } from '@shared/components/share-profile/share-profile.component';
import { App } from '@capacitor/app';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidationService } from 'src/app/services/validation.service';
import { WebBlocker } from '@shared/decorators/web-blocker.decorator';
import { NotAvailableComponent } from '@shared/components/not-available/not-available.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.page.html',
  styleUrls: ['./chat.page.scss'],
  providers: [UserService, MatchService, FcmService, UtilService, MediaService,IonRouterOutlet]
})
export class ChatPage implements OnInit {
  @ViewChild(IonContent) content: IonContent | any;
  @ViewChild('chatInput') chatInput: any;
  public myForm: any;
  public theMsgControl: FormControl =
    new FormControl('', Validators.compose([Validators.required, Validators.maxLength(1000)]));

  private lastTap: number = 0;
  private lastTappedMessageId: string | null = null;
  private doubleTapThreshold: number = 400;
  
  public userData: any;
  public selfiesApproved: boolean = false;
  public otherSoul: any;
  public fromProfileDisplay: boolean = false;
  public respondedMessage: any = null;
  public respondingMessage: boolean = false;
  public showRate: boolean = true;
  messages:any = [];
  public messagesMap = new Map();
  public showFab: boolean = false;
  private showedReactionHint: boolean = false;
  private showedRespondHint: boolean = false;
  private showedReadingConfirmationCallout = false;
  private lastNewMessageId: string | any;
  private lastDay = '';
  private today : any;
  private firstOpenDate = new Date();
  private refreshSubs: Subscription = new Subscription();
  private pauseSubs: Subscription = new Subscription();
  private resumeSubs: Subscription = new Subscription();
  //  private keyboardSubscription : Subscription = new Subscription();
  private msgsSent = 0;
  public isLoaded: boolean = false;
  private isAndroid: boolean = true;
  private canUseWithoutAds: boolean = false;
  private userIsTyping: boolean = false;
  private elapsed = 60;
  public clickValidateProfile: boolean = false;
  private sentNoMessagesAtFirst: boolean = false;
  private isNative: boolean = true;
  public fromVegmatchModal = false;

  public formattedelapsed = this.elapsed.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
  })

  private requests: number= 0;

  // @Output() openModalAppShare = new EventEmitter<any>()
  public goHome() {
    // Doesn't work. Will need to pop and in the previous screen, do the select(0). 
    //Check how to return a value to the previous screen
    console.log('goHome called..');
    // this.navCtrl.pop();
    // this.navCtrl.parent.select(2);
  }

  public showProfileShare: boolean = false;
  public showAlertRateNowChat: boolean = false;
  private eventSubscription: Subscription|any;

  // private unregisterFunction: Function;

  public backButton: Subscription|any;
  constructor(
    private userService: UserService,
    public modalCtrl: ModalController,
    public platform: Platform,
    private route: ActivatedRoute,
    private router: Router,
    public matchService: MatchService,
    private translate: TranslateService,
    public mediaSP: MediaService,
    public navParams: NavParams,
    private purchaseServiceProvider: PurchaseService,
    public toastCtrl: ToastController,
    private analytics: AnalyticsService,
    public alertCtrl: AlertController,
    private util: UtilService,
    public eventService: EventService,
    public valitationService: ValidationService,
    public loadingCtrl: LoadingController,
    public element: ElementRef
  ) {
    this.isNative = this.util.isNative();
    this.myForm = new FormGroup({
      msgControl: this.theMsgControl
    });
  }

  ngOnInit() {
  }

  sendSocketMessage(theMsg: string) {
    // this.socket.emit('send-message', { text: theMsg });
  }

  sendMyChat(myID: string, otherSoulID: string) {
    // this.socket.emit('add-myChat', { me: myID, otherSoul: otherSoulID });
  }

  ionViewWillEnter() {
    this.backButton = this.platform.backButton.subscribe(() => {
      this.dismiss();
    });

    this.viewInfo();

    this.route.queryParamMap.subscribe(params => {
      this.selfiesApproved = params.get('selfiesApproved') === 'true';
    });

    Preferences.get({key:'chatFirstOpenDate'}).then((val:any)=>{
      val = val.value ? JSON.parse(val.value) : null;
      if(val == null){
        Preferences.set({key:'chatFirstOpenDate', value: JSON.stringify(new Date())}).then(()=>{
          console.log('chat first open date stored');
        })
      } else {
        this.firstOpenDate = new Date(val);
      }
    })

    // connect to socket.io server
    // this.socket.connect();

    this.sendMyChat(this.userData?._id.$oid, this.otherSoul._id.$oid);

    this.getMessages().subscribe(aMessage => {
      console.log('Message received: ' + JSON.stringify(aMessage));
    });

    this.receiveReactToMessage().subscribe((reaction:any) => {
      console.log('receiveReactToMessage received: ' + JSON.stringify(reaction));

      let msgId = reaction['messageId'];
      console.log('msgId: ' + msgId);
      if (!msgId) {
        return;
      }

      let message = this.messagesMap.get(msgId);
      if (!message) {
        return;
      }

      message.reaction = 1;
      this.messagesMap.set(msgId, message);
      this.messages = Array.from(this.messagesMap.values());
    });

    this.receiveUnReactToMessage().subscribe((reaction:any) => {
      console.log('receiveUnReactToMessage received: ' + JSON.stringify(reaction));

      let msgId = reaction['messageId'];
      console.log('msgId: ' + msgId);
      if (!msgId) {
        return;
      }

      let message = this.messagesMap.get(msgId);
      if (!message) {
        return;
      }

      message.reaction = null;
      this.messagesMap.set(msgId, message);
      this.messages = Array.from(this.messagesMap.values());
      console.log('Messages:' + JSON.stringify(this.messages));
    });
  }

  receiveReactToMessage(): Observable<{}> {
    let observable = new Observable<{}>(observer => {
      // this.socket.on('reactToMessage', (data:any) => {
        // update observable when the 'message' event is sent from the server
        observer.next({});
      // });
    });
    return observable;
  }

  receiveUnReactToMessage(): Observable<{}> {
    let observable = new Observable<{}>(observer => {
      // this.socket.on('unreactToMessage', (data:any) => {
        // update observable when the 'message' event is sent from the server
        observer.next({});
      // });
    });
    return observable;
  }

  getMessages(): Observable<{}> {
    let observable = new Observable<{}>(observer => {
      // this.socket.on('message', (data:any) => {
        // update observable when the 'message' event is sent from the server
        observer.next({});
      // });
    });
    return observable;
  }

  viewInfo() {
    this.userData = this.navParams.get('me');
    this.fromProfileDisplay = this.navParams.get('fromProfileDisplay');
    this.canUseWithoutAds = this.purchaseServiceProvider.canUseWithoutAds(this.userData)
    console.log('canUseWithoutAds: ' + this.canUseWithoutAds);
    this.otherSoul = this.navParams.get('otherSoul');
    this.isAndroid = this.platform.is('android');
    this.fromVegmatchModal = this.navParams.get('fromVegmatchModal') || false;


    this.isNative = this.util.isNative();
    this.loadProfilePictureAndMessages();
    this.today = this.userService.formatDate(new Date(), this.userData);


    this.subscribeRefresher();

    this.platform.ready().then(() => {
      this.isAndroid = this.platform.is('android');

      App.addListener('appStateChange', (state) => {
        if (!state.isActive) {
          console.log('[CHAT] App paused');
          this.unSubscribeRefresher();
        }
      });

      // Subscribing to the resume event
      App.addListener('appStateChange', (state) => {
        if (state.isActive) {
          console.log('[CHAT] App resumed');
          this.subscribeRefresher();
        }
      });



    });
  }

  async startRecord() {
    await VoiceRecorder.hasAudioRecordingPermission().then((result: GenericResponse) => {
      if(result.value != true){
        VoiceRecorder.requestAudioRecordingPermission().then(async (result: GenericResponse) => {
          console.log(result)
          this.requests++;
          if (this.requests >= 2) {

            let message = this.translate.instant('pleaseAuthorizeMicrophoneAccess')

            this.util.showModalAlertRequestPermission(message, AndroidSettings.ApplicationDetails, IOSSettings.App)

            return;
          }
        })
      }
    });

    VoiceRecorder.hasAudioRecordingPermission().then((result: GenericResponse) => {
      if(result.value == true){
        this.elapsed = 60;
        this.formattedelapsed = this.elapsed.toLocaleString('en-US', {
          minimumIntegerDigits: 2,
          useGrouping: false
        })
        this.mediaSP.startRecord();
        this.incrementElapsed();
      } 
    })

  }

  incrementElapsed() {
    setTimeout(() => {
      if (this.elapsed == 1) {
        this.stopRecord();// stop and send
        return;
      }
      this.elapsed -= 1;
      this.formattedelapsed = this.elapsed.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
      })
      if (this.mediaSP.recording) {
        this.incrementElapsed();
      }
    }, 980);// assuming the logic will take around 20ms
  }

  async stopRecord() {
    let generatedFilePath = await this.mediaSP.stopRecord()
    console.log('generatedFilePath: ' + generatedFilePath);
    console.log(generatedFilePath);
    console.log(this.mediaSP.fileName)
    //this.mediaSP.playAudio(this.mediaSP.fileName);

    this.sendAudio(generatedFilePath);
  }


  private loadProfilePictureAndMessages() {
    this.userData.profilePic = PicturesPage.gray;// Set initially

    let theFile: string = 'picture0.jpg';

    let i: number = 0;
    for (i = 0; i < 8; i++) {
      const aPicName = 'picture' + i;
      const aPic = this.userData[aPicName];
      if (aPic != null) {
        this.userData.profilePic = this.userService.getImageURL(aPic.$oid);
        break;
      }
    }
    this.loadMessages(this.userData, this.otherSoul);

  }

  public unSubscribeRefresher() {
    this.refreshSubs.unsubscribe();
  }

  public subscribeRefresher() {
    this.refreshSubs = interval(1000 * 5).subscribe(x => {
      if (this.userData == null) {
        // this.unregisterFunction();
        this.modalCtrl.dismiss('logout');
        return;
      }
      this.markMatchAsReadOnOpen()
      console.log('other id in chat: ' + this.otherSoul._id.$oid)
      console.log('userData in chat: ' + JSON.stringify(this.userData))
      console.log('matches in chat: ' + JSON.stringify(this.userData.matches));
      if (this.messages.length > 0) {
        console.log('this.msgsSent: ' + this.msgsSent);
        this.loadNewMessages(this.userData, this.otherSoul, this.messages[this.messages.length - 1 - this.msgsSent]);
      }
    });
  }

  async openProfile() {

    if (this.fromProfileDisplay) {
      this.dismiss();
      return;
    }


    let modal = this.modalCtrl.create({component:ProfileDisplayPage, componentProps: { theSoul: this.otherSoul }});
    (await modal).onDidDismiss().then((val) => {
      console.log('Data returned from ProfileDisplayPage modal: ' + JSON.stringify(val.data));

      if (val.data == 'logout') {
        // this.unregisterFunction();
        this.modalCtrl.dismiss('logout');
        return;
      }

      if (val.data != null && val.data == 'removed') {
        this.dismiss();
        return;
      }

    });

    (await modal).present();
  }

  @WebBlocker()
  async openAvocadoStore() {
    this.analytics.registerEvent(AnalyticsService.avocado);
    this.analytics.registerEvent(AnalyticsService.avcdFromReadConf);
    let modal; 
    modal = this.modalCtrl.create({component: StoreV2Page, componentProps: {me: this.userData, type: "avocado_club", from:'chat'}, showBackdrop:true, backdropDismiss:true});
    (await modal).present();
  }

  markSentRead() {
    console.log('this.messages.length: ' + this.messages.length);
    for (let i = this.messages.length - 1; i >= 0; i--) {
      let aMessage = this.messages[i];
      console.log('aMessage: ' + i + ' - ' + JSON.stringify(aMessage));
      if (aMessage.position == 'right') {
        if (!aMessage.read) {
          aMessage.read = true;
        } else {
          // if it was already marked ready, no need to keep going.
          return;
        }
      }
    }
  }

  loadNewMessages(userData: any, otherSoul: any, lastMsg: any) {

    var theObs: Observable<any>;
    theObs = this.userService.getNewMessages(userData, otherSoul, lastMsg);

    theObs.subscribe(async data => {
      console.log('getNewMessages subscribe entered');
      if (data != '{not ok}') {
        console.log('data = ' + JSON.stringify(data));
        data = JSON.parse(data);

        if (data.lastRead != undefined) {
          // No new message. Handle wheather last message has been read or not
          console.log('No new message. Handle wheather last message has been read or not');
          if (data.lastRead) {
            // mark my messages read
            this.markSentRead();
          }
        }

        if (data != null && data.length > 0 && this.lastNewMessageId != data[0]._id.$oid) {
          let nextHint = null;
          if (!this.showedReactionHint) {
            nextHint = "reaction";
          } else if (!this.showedRespondHint) {
            nextHint = "respond";
          }

          for (let i = data.length - 1; i > -1; i--) {
            this.markSentRead();

            let aMessage = data[i];
            var d = new Date(aMessage.time * 1000);
            aMessage.date = this.userService.formatDate(d, this.userData);
            aMessage.time = this.userService.formatTime(d);
            if (aMessage.date != this.lastDay) {
              aMessage.newday = true;
              this.lastDay = aMessage.date;
              if (aMessage.date == this.today) {
                aMessage.date = 'Today';
              }

            }
            if (aMessage.sent) {
              aMessage.position = 'right';

              if (!this.showedReadingConfirmationCallout && !this.purchaseServiceProvider.isPremium(this.userData) && d > this.firstOpenDate) {
                aMessage.readingConfirmationCallout = true;
                this.showedReadingConfirmationCallout = true;
              }
            } else {
              aMessage.position = 'left';
              aMessage.img = otherSoul.firstPic

              if (nextHint == "reaction") {
                aMessage.reactionHint = true;
                nextHint = "respond";
                this.showedReactionHint = true;
              } else if (nextHint == "respond") {
                aMessage.respondHint = true;
                nextHint = null;
                this.showedRespondHint = true;
              }
            }


            let msg: string = aMessage.message.trim();
            console.log('msg: ' + msg)
            if (msg.startsWith('{') && msg.endsWith('}')) {
              try {
                console.log('Will set filename..');
                let audioMsg = JSON.parse(msg);
                aMessage.filename = audioMsg.filename;
                aMessage.duration = audioMsg.duration;
                aMessage.fileId = audioMsg.fileId;
                
              } catch (error) {
                console.log("Text message starting with { and ending with }. Error Trying to parse text as JSON");
                aMessage.message = msg;
              }
            } else {
              aMessage.message = msg;
            }

            this.lastNewMessageId = aMessage._id.$oid;
            this.messagesMap.set(aMessage._id.$oid, aMessage);
            this.messages = Array.from(this.messagesMap.values());

            console.log("Mensagens: " + JSON.stringify(this.messages))
          }

          this.markAsRead();
          this.matchService.markAsRead(otherSoul);

          this.scrollToBottom();
          this.msgsSent = 0;

        }

      } else {

        await this.userService.clearLocalStorage();
        this.userData = null;
        // this.unregisterFunction();
        this.modalCtrl.dismiss('logout');
        return;

      }


    },
      err => {
        if (this.countErrorMsg == 10) {
          this.util.showTopToastUnableToConnect(this.toastCtrl);
          this.countErrorMsg = 0;
        } else {
          this.countErrorMsg++;
        }
        console.log('Error: ' + JSON.stringify(err));
      })

  }

  private countErrorMsg: number = 0;

  markMatchAsReadOnOpen() {
    console.log('markAsReadNoMessages entered');
    var theObs: Observable<any>;
    theObs = this.userService.markRead(this.userData?._id.$oid,
      this.otherSoul._id.$oid,
      false);

    theObs.subscribe(data => {
      console.log('chat.markAsRead subscribe entered');
      console.log('data = ' + JSON.stringify(data));
    },
      err => {
        console.log('Error: ' + JSON.stringify(err));
      })
  }

  markAsRead() {

    var theObs: Observable<any>;
    theObs = this.userService.markRead(this.userData?._id.$oid,
      this.otherSoul._id.$oid,
      true);

    theObs.subscribe(data => {
      console.log('chat.markAsRead subscribe entered');
      console.log('data = ' + JSON.stringify(data));
    },
      err => {
        console.log('Error: ' + JSON.stringify(err));
      })
  }

  async ionViewWillLeave() {
    if(this.platform.is('android')) {
      if(this.backButton){
        this.backButton.unsubscribe();
      }
    }
    if (this.isNative && this.sentNoMessagesAtFirst && this.sentOneThisTime) {

      if(localStorage.getItem('showProfileShare')) {

        localStorage.removeItem('showProfileShare')
        // this.eventService.publish('openModalAppShare', true);

        const modal = await this.modalCtrl.create({
          component: ShareProfileComponent,
          componentProps: {
            userId: this.userData?._id.$oid
          },
          cssClass: 'custom-class-modal' 
        });
        modal.present();

      }else if(localStorage.getItem('showAlertRateNowChat')){
        localStorage.removeItem('showAlertRateNowChat')
        
        localStorage.setItem('showProfileShare', 'true')
        
        this.util.showAlertRateNowChat();

      } else{
        localStorage.setItem('showAlertRateNowChat', 'true')
        this.util.showAlertRateNow();
      }
    }

    this.unSubscribeRefresher();
    this.pauseSubs.unsubscribe();
    this.resumeSubs.unsubscribe();
    this.matchService.chattingToSoul = null;

    console.log('ionViewWillLeave Disconnect socket');
    // this.socket.disconnect();

    console.log("Stop other audio...")
    
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ChatPage');
    if (this.content != undefined && this.content != null) {
      this.content.scrollToPoint(0, 999999999, 300);
    }
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter ChatPage');

    //this.loadProfilePicture();
    this.matchService.chattingToSoul = this.otherSoul._id.$oid;
    if (this.content != undefined && this.content != null) {
      this.content.scrollToPoint(0, 999999999, 300);
    }

    this.content.ionScrollEnd.subscribe((data:any) => {

      console.log('ionScrollEnd...');
      let dimensions = this.content.getContentDimensions();

      let scrollTop = this.content.scrollTop;
      let contentHeight = dimensions.contentHeight;
      let scrollHeight = dimensions.scrollHeight;

      console.log('scrollTop: ' + scrollTop);
      console.log('contentHeight: ' + contentHeight);
      console.log('scrollHeight: ' + scrollHeight);

      if ((scrollTop + contentHeight + 200) > scrollHeight) {
        this.showFab = false;
      } else if (!this.userIsTyping) {
        this.showFab = true;
      }

    });
  }

  async loadMessages(userData: any, otherSoul: any) {
    let loader = this.loadingCtrl.create({
      message: this.translate.instant('msgOneMomentPlease'),
    });
    (await loader).present();

    var theObs: Observable<any>;
    theObs = this.userService.getMessages(userData, otherSoul);

    theObs.subscribe(async data => {
      console.log('subscribe entered');
      console.log('data = ' + JSON.stringify(data));
      if (data != null && data != '{not ok}') {
        this.messages = [];
        this.sentNoMessagesAtFirst = true;
        let nextHint :any= "reaction";
        this.showedReadingConfirmationCallout = false;

        for (let i = data.length - 1; i > -1; i--) {

          let aMessage = data[i];

          let msg: string = aMessage.message.trim();
          if (msg.startsWith('{') && msg.endsWith('}')) {
  
            try {
              console.log('Will set filename..');
              let audioMsg = JSON.parse(msg);
              aMessage.filename = audioMsg.filename;
              aMessage.duration = audioMsg.duration;

            } catch (error) {
              console.log("Text message starting with { and ending with }. Error Trying to parse text as JSON");
              aMessage.message = msg;
            }
          } else {
            aMessage.message = msg;
          }


          var d = new Date(aMessage.time * 1000);
          aMessage.date = this.userService.formatDate(d, this.userData);
          aMessage.time = this.userService.formatTime(d);
          if (aMessage.date != this.lastDay) {
            aMessage.newday = true;
            this.lastDay = aMessage.date;
            if (aMessage.date == this.today) {
              aMessage.date = 'Today';
            }
          }

          // Collect the owner of the message
          this.collectOwner(aMessage, data);

          if (aMessage.sent) {
            aMessage.position = 'right';
            aMessage.img = this.userData?.profilePic;
            this.sentNoMessagesAtFirst = false;

            if (!this.showedReadingConfirmationCallout && !this.purchaseServiceProvider.isPremium(this.userData) && d > this.firstOpenDate) {
              aMessage.readingConfirmationCallout = true;
              this.showedReadingConfirmationCallout = true;
            }
          } else {
            aMessage.position = 'left';
            aMessage.img = otherSoul.firstPic

            if (nextHint == "reaction") {
              aMessage.reactionHint = !(aMessage.reaction == 1);
              nextHint = "respond";
              this.showedReactionHint = true;
            } else if (nextHint == "respond") {
              aMessage.respondHint = true;
              nextHint = null;
              this.showedRespondHint = true;
            }
          }

          this.messagesMap.set(aMessage._id.$oid, aMessage);
          this.messages = Array.from(this.messagesMap.values());
          console.log("Mensagens:" + JSON.stringify(this.messages));
        }
        this.isLoaded = true;
      }

      this.scrollToBottom();
      (await loader).dismiss();

    },
      async err => {
        this.util.showTopToastUnableToConnect(this.toastCtrl);
        (await loader).dismiss();
        console.log('Error: ' + JSON.stringify(err));
        if (this.content != undefined && this.content != null) {
          this.content.scrollToPoint(0, 999999999, 300);
        }
      })

  }


  collectOwner(aMessage: any, data: any = this.messages) {
    // Collect the owner of the message
    if (aMessage.inResponseTo && aMessage.inResponseTo.$oid) {
      const repliedMessageOid = aMessage.inResponseTo.$oid;
      const repliedMessage = data.find((msg: { _id: { $oid: any; }; }) => msg._id && msg._id.$oid === repliedMessageOid);
    console.log('repliedMessage: ' + JSON.stringify(repliedMessage));
    if (repliedMessage) {
      if (repliedMessage.position == 'right') {
        //Add translation
        aMessage.inResponseTo.owner = this.translate.instant('you');
      }
      else{
         aMessage.inResponseTo.owner = this.otherSoul.firstName;
      }
    }
    }
  }

  sendAudio(generatedFilePath: string) {

    let filename = this.mediaSP.fileName;
    console.log('filename: ' + filename)
    let duration: number = this.mediaSP.duration;
    console.log('duration: ' + duration);

    let aPromise: Promise<FileUploadResult> = this.userService.uploadAudio(generatedFilePath, this.userData, filename);
    aPromise.then((value: FileUploadResult) => {
      console.log('FileUploadResult responseCode: ' + JSON.stringify(value.response));

      let msg = {
        msgType: 'audio',
        filename: filename,
        duration: duration,
        fileId: value.response
      };
      this.sendMsg(msg);

    }).catch(error => {
      this.util.showTopToastUnableToConnect(this.toastCtrl);
      console.log('Error uploading audio: ' + JSON.stringify(error));
    });

  }

  async showModalAlert(message:any) {
    let alert = this.alertCtrl.create({
      //title: this.translate.instant('statisticalOnly'),
      subHeader: message,
      buttons: [
        // {
        //   text: this.translate.instant('cancel'),
        //   handler: () => {
        //     console.log('cancel clicked');
        //     return;

        //   }
        // },
        {
          text: 'OK',
          handler: () => { }
        }
      ]
    });

    (await alert).present();
  }

  send() {
    this.chatInput.setFocus();
    let msg = this.myForm.controls['msgControl'].value;

    this.element.nativeElement.getElementsByTagName('textarea')[0];
    const textArea = this.element.nativeElement.getElementsByTagName('textarea')[0];
    textArea.style.overflow = 'hidden';
    textArea.style.height = 'auto';

    if (!this.myForm.valid) {
      if (msg != null && msg.length > 1000) {
        this.showModalAlert(this.translate.instant('msg1000Characters'));
      }
      let as: Autosize = new Autosize(this.element)
      as.adjust();
      return;
    }
    this.myForm.controls['msgControl'].setValue('');

    this.sendMsg(msg);

    this.chatInput.setFocus();
  }

  private sentOneThisTime: boolean = false;

  sendMsg(msg:any) {
    console.log('sendMsg entered');
    this.sentOneThisTime = true;
    let respondedMessageId:any = null;
    if (this.respondedMessage != null) {
      respondedMessageId = this.respondedMessage._id.$oid;
    }

    var theObs: Observable<any>;
    theObs = this.userService.sendMessage(this.userData?._id.$oid, this.otherSoul._id.$oid, msg, this.userData, respondedMessageId);
    theObs.subscribe(async data => {
      console.log('sendMessage subscribe entered');
      console.log('data for sendMessage = ' + JSON.stringify(data));
      if (data == '{not ok}') {
        await this.userService.clearLocalStorage();
        return;
      }
      let aMessage: any = {};

      console.log(JSON.stringify(msg));
      if (typeof msg == "object") {
        aMessage.filename = msg.filename;
        aMessage.duration = msg.duration;
        aMessage.fileId = msg.fileId
      } else {
        aMessage.message = msg;
      }
      

      var d = new Date();
      aMessage.date = this.userService.formatDate(d, this.userData);
      aMessage.time = this.userService.formatTime(d);
      if (aMessage.date != this.lastDay) {
        aMessage.newday = true;
        this.lastDay = aMessage.date;
        aMessage.date = 'Today';
      }
      aMessage.position = 'right';
      this.otherSoul.theMessage = msg;
      this.otherSoul.relevantTime = aMessage.date + ' ' + aMessage.time;
      this.otherSoul.newBadge = false;

      //register sendMessage event (after it actually sends)
      this.analytics.registerEvent(AnalyticsService.sendMessageEvent);
      console.log("! Analytics 'message' event sent !");
      this.msgsSent++;
      aMessage.img = this.userData?.profilePic;

      try {
        let msgId = { $oid: data };
        aMessage._id = msgId;
        console.log('Message to add: ' + JSON.stringify(aMessage));
        if (respondedMessageId != null) {
          aMessage.inResponseTo = { $oid: respondedMessageId };
          this.collectOwner(aMessage, this.messages);
        }
        if (!this.showedReadingConfirmationCallout && !this.purchaseServiceProvider.isPremium(this.userData) && d > this.firstOpenDate) {
          aMessage.readingConfirmationCallout = true;
          this.showedReadingConfirmationCallout = true;
        }
        console.log('Message to add: ' + JSON.stringify(aMessage));
        this.messagesMap.set(aMessage._id.$oid, aMessage);
        this.messages = Array.from(this.messagesMap.values());
      } catch (error) {
        console.log('Error adding message: ' + JSON.stringify(error));
      }

      // Limpa o campo de mensagem apenas se o envio for bem-sucedido
      this.myForm.controls['msgControl'].setValue('');
      this.scrollToBottom();
      this.respondedMessage = null;
      this.respondingMessage = false;
    },
      err => {
        // Em caso de erro, mantém o texto original
        if (typeof msg != "object") {
          this.myForm.controls['msgControl'].setValue(msg);
        } else {
          this.myForm.controls['msgControl'].setValue('');
        }
        this.showForcedConnectionErrorToast();
        console.log('Error: ' + JSON.stringify(err));
      })
  }

  public dismiss() {

    // this.unregisterFunction();
    let contentElement = document.getElementById("contentDiv");
    if (contentElement == undefined || contentElement == null) {
      console.log("dismiss chat");
      return;
      // This should not happen anymore now that we call the unregisterFunction. Keeping it here just in case.
      // In the future, we may register the registerBackButtonAction method from app.component and deal with view.id == ChatPage or other pages
    }
    contentElement.classList.add('animation');

    console.log('fromVegmatchModal: ', this.fromVegmatchModal);


    if (this.fromVegmatchModal) {
      this.modalCtrl.dismiss();
      this.router.navigateByUrl('/tabs/chat-list');
    } else if (this.msgsSent > 0) {
      this.modalCtrl.dismiss('shouldRefreshList');
    } else if (this.clickValidateProfile) {
      this.modalCtrl.dismiss('initValidationProfile');
    } else {
      this.modalCtrl.dismiss(null);
    }
  }

  public scrollToBottom() {
    console.log('scrollToBottom...');
    if (this.content != undefined && this.content != null ) {
      console.log('Not null.. Will scroll...');
      this.content.scrollToPoint(0, 999999999, 300);
    }
    
    this.showFab = false;

  }

  public changeUserTypingState() {
    this.userIsTyping = !this.userIsTyping;
    if (this.userIsTyping) {
      this.scrollToBottom();
    }
  }

  swipeEvent(e:any) {
    console.log('swiped');
    if (e == undefined || e == null || e.deltaX < 0) {
      // slide left
      return;
    }
    console.log(JSON.stringify(e));
    this.dismiss();

    // Check direction left to right
    // Check if works on other places this is opened
    // Can we have a better animation?
    //this.dismiss();
  }

  swipeEventAudio(e:any) {
    if (!this.mediaSP.recording) {
      return;
    }
    try {
      console.log('swiped');
      if (e == undefined || e == null || e.deltaX > 0) {
        // slide right
        return;
      }
      console.log(JSON.stringify(e));
      this.cancelAudio();

    } catch (error) {
      console.error(JSON.stringify(error), error);
    }
  }

  cancelAudio() {
    this.mediaSP.stopRecord();
    this.mediaSP.deleteLastLocalAudioIfExists();
  }

  handleTouchStart(message: any){
    // Implement animantion or logic for touch start if needed
  }

  handleTouchEnd(message: any) {
    const now = Date.now();
    const messageId = message?._id?.$oid;
    console.log("Clicked once")

    if (now - this.lastTap < this.doubleTapThreshold && this.lastTappedMessageId === messageId) {
      console.log("Double tap detected");
      this.handleMessageReaction(message);
      this.lastTap = 0;
      this.lastTappedMessageId = null;
    } else {
      console.log("Not fast or first tim")
      this.lastTap = now;
      this.lastTappedMessageId = messageId;
    }
  }

  handleMessageReaction(msg: any, reaction: number = 1) {
    if (msg.position != 'left') {
      return;
    }
    if (msg.reaction == 1) {
      this.userService.undoReactionToMessage(msg._id.$oid, reaction, this.userData).subscribe(async data => {
        console.log("UndoReactToMessage subscribe");
        console.log(data);

        let msgId = msg._id.$oid;
        let message = this.messagesMap.get(msgId);
        message.reaction = null;
        this.messagesMap.set(msgId, message);
        this.messages = Array.from(this.messagesMap.values());
      },
        error => {
          this.util.showTopToastUnableToConnect(this.toastCtrl);
          console.log(error);
        })
    } else {
      this.userService.reactToMessage(msg._id.$oid, reaction, this.userData).subscribe(async data => {
        console.log("ReactToMessage subscribe");
        console.log(data);

        let msgId = msg._id.$oid;
        let message = this.messagesMap.get(msgId);
        message.reaction = 1;
        message.reactionHint = false;
        this.messagesMap.set(msgId, message);
        this.messages = Array.from(this.messagesMap.values());
      },
        error => {
          this.util.showTopToastUnableToConnect(this.toastCtrl);
          console.log(error);
        })
    }
  }

  async showRespondMessage(msg: any, slidingItem: IonItemSliding) {
    this.respondedMessage = msg;
    this.respondingMessage = true;
    await slidingItem.close();
  }

  dismissRespondMessage() {
    this.respondingMessage = false;
    this.respondedMessage = null;
  }

scrollToRespondedMessage(respondedMsgId: string) {
  // Rola para a mensagem respondida (a ion-item-sliding)
  document.getElementById(respondedMsgId + '-sliding')?.scrollIntoView({ behavior: "smooth", block: "center" });

  // Adiciona a classe 'glow' à bolha da mensagem
  setTimeout(() => document.getElementById(respondedMsgId + "-bubble")?.classList.add("glow"), 300);

  // Remove a classe 'glow' da bolha da mensagem
  setTimeout(() => document.getElementById(respondedMsgId + "-bubble")?.classList.remove("glow"), 1050);
}

  async handleValidation(){
    // Verifica se não é Android nem iOS (web)
    if (!this.platform.is('android') && !this.platform.is('ios')) {
      this.showNotAvailableModal();
      return;
    }
    
    this.clickValidateProfile = true;
    if (this.fromProfileDisplay) {
      this.dismiss();
      return;
    }else {
      this.dismiss();
    }
    this.valitationService.openValidation();
  }

  async showNotAvailableModal() {
    const modal = await this.modalCtrl.create({
      component: NotAvailableComponent,
      componentProps: {
        downloadLink: environment.adjustDownloadLink
      },
      cssClass: 'custom-class-modal'
    });

    await modal.present();

    modal.onDidDismiss().then(() => {
      // Usuário permanece no chat
    });
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = "assets/imgs/no-picture.png"; // Caminho da imagem de fallback
  }

  private async showForcedConnectionErrorToast() {
    // Ignora o controle de frequência do UtilService
    let toast = await this.toastCtrl.create({
      message: this.translate.instant('unableToConnectMsg'),
      position: 'top',
      duration: 4000,
      buttons: [
        {
          text: this.translate.instant('close'),
          role: 'cancel',
        }
      ],
    });
    toast.present();
  }
}
